import React, { useEffect } from 'react'
import { ICSModal } from '../../components/ICSModal/ICSModal'
import { ModalHeader } from 'reactstrap'
import { LoadIndicator } from 'devextreme-react'
import LostPasswordBody from './LostPasswordBody'
import './LostPassword.css'
import { DefaultState } from '../../types'
import { useSelector, useDispatch } from 'react-redux'
import LostPasswordNotifyAdmin from './LostPasswordNotifyAdmin'
import LostPasswordEmailUser from './LostPasswordEmailUser'
import { isEmailEnabled } from '../../redux/slices'
import LostPasswordNotConfigured from './LostPasswordNotConfigured'
import ICSErrorCard from '../../components/ICSErrorCard/ICSErrorCard'

interface LostPasswordProps {
  visible: boolean
  onHiding: () => void
}

const LostPassword = ({ visible, onHiding }: LostPasswordProps) => {
  const accounts = useSelector((state: DefaultState) => state.accounts)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(isEmailEnabled())
    //dispatch(loginSlice.actions.resetState()) - why is this here?
  }, [])

  if (typeof accounts.error == 'object' && accounts.error?.code === 'error') {
    return (
      <ICSErrorCard
        code={accounts.error.code}
        message={accounts.error.message}
        fields={accounts.error.fields}
      />
    )
  } else if (accounts.error) {
    return <div> {accounts.error} </div>
  } else if (accounts.loading) {
    return <LoadIndicator />
  } else if (
    accounts.passwordReset === '' ||
    accounts.registrationEnabled === true
  ) {
    return (
      <ICSModal
        visible={visible}
        onHiding={onHiding}
        id="lostpassword-modal"
        defaultWidth="80vw"
      >
        <ModalHeader id="lostpassword-header">Reset Password</ModalHeader>
        <LostPasswordBody />
      </ICSModal>
    )
  } else if (
    accounts.passwordReset == 'notifyAdmin' ||
    (accounts.passwordReset == 'emailUser' && accounts.emailEnabled == false)
  ) {
    return (
      <ICSModal
        visible={visible}
        onHiding={onHiding}
        id="lostpassword-modal"
        defaultWidth="80vw"
      >
        <ModalHeader id="lostpassword-header">Reset Password</ModalHeader>
        <LostPasswordNotifyAdmin />
      </ICSModal>
    )
  } else if (
    accounts.passwordReset === 'emailUser' &&
    accounts.emailEnabled === true
  ) {
    return (
      <ICSModal
        visible={visible}
        onHiding={onHiding}
        id="lostpassword-modal"
        defaultWidth="80vw"
      >
        <ModalHeader id="lostpassword-header">Reset Password</ModalHeader>
        <LostPasswordEmailUser />
      </ICSModal>
    )
  } else {
    return (
      <ICSModal
        visible={visible}
        onHiding={onHiding}
        id="lostpassword-modal"
        defaultWidth="80vw"
      >
        <ModalHeader id="lostpassword-header">
          Reset Password Not Configured
        </ModalHeader>
        <LostPasswordNotConfigured />
      </ICSModal>
    )
  }
}

export default LostPassword
